import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/warehouseStructure/warehouseEleven/img2.webp";

function WarehouseEleven() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className="warehouseEleven">
        <img
          className={`${isVisible ? "visible" : ""}`}
          src={img1}
          alt=""
          width={"300px"}
        />
        <div className="elevenText">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("warehouse_eleven_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("warehouse_eleven_text")}
          </p>
        </div>
      </div>
    </VisibilitySensor>
  );
}
export default WarehouseEleven;
